var LibraryView,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

LibraryView = (function(_super) {
  __extends(LibraryView, _super);

  function LibraryView(with_items, options) {
    this.with_items = with_items != null ? with_items : false;
    this.check_cart = __bind(this.check_cart, this);
    this.add_to_cart = __bind(this.add_to_cart, this);
    this.hide_info = __bind(this.hide_info, this);
    this.show_info = __bind(this.show_info, this);
    Observable(this, 'in_cart', false);
    LibraryView.__super__.constructor.call(this, this.with_items, options);
  }

  LibraryView.prototype.show_info = function(item) {
    assetsgrid.loaded(false);
    tags.tagcloud.loaded(false);
    this.asset(item);
    this.check_cart(item);
    return this.loaded(true);
  };

  LibraryView.prototype.hide_info = function() {
    assetsgrid.loaded(true);
    tags.tagcloud.reload();
    return this.loaded(false);
  };

  LibraryView.prototype.add_to_cart = function(form_element) {
    return $.post_json('/library/cart/' + this.asset().id + '.json?_method=put', (function(_this) {
      return function(data) {
        return _this.asset().in_cart(true);
      };
    })(this));
  };

  LibraryView.prototype.check_cart = function(asset) {
    return $.get_json('/library/cart/assets/' + asset.id + '.json', (function(_this) {
      return function(data) {
        return _this.in_cart(data.in_cart);
      };
    })(this));
  };

  return LibraryView;

})(InfoView);

//# sourceMappingURL=library.js.map
